import { NgModule } from '@angular/core';
import { ServerConfigService } from '@app/configuration/server-config.service';
import { LocalStorage } from '@features/storage/local-storage';
import { WINDOW_PROVIDERS } from '@lib/browser/window-providers';
import { ServerTimeService } from '@lib/time/server-time.service';
import { TimerService } from '@lib/time/timer.service';

@NgModule({
  imports: [],
  providers: [
    ServerConfigService,
    TimerService,
    WINDOW_PROVIDERS,
    ServerTimeService,
    LocalStorage,
  ],
})
export class SharedModule {}
